window.jQuery = window.$ = require('jquery');

const productVideoInit = () => {
    var productVideo = $(document).find('.product-video');

    // Product Video - Play/Pause, Mute/Unmute and fullscreen mode
    productVideo.each(function () {
        var video = $(this).find('video');
        var plainVideo = video.get(0);
        var playBtn = $(this).find('.play');
        var pauseBtn = $(this).find('.pause');
        var soundBtn = $(this).find('.sound');
        var fullScreenBtn = $(this).find('.fullScreen');
        video.on('ended', () => {
            playBtn.fadeIn();
        });
        playBtn.on('click', function() {
            if (plainVideo.paused) {
                plainVideo.play();
                playBtn.fadeOut();
                pauseBtn.fadeIn();
            }
        });
        pauseBtn.on('click', function() {
            if (!plainVideo.paused) {
                plainVideo.pause();
                playBtn.fadeIn();
                pauseBtn.fadeOut();
            }
        });
        soundBtn.on('click', function(e) {
            e.stopImmediatePropagation();
            plainVideo.muted = !plainVideo.muted;
            if (plainVideo.muted) {
                soundBtn.find('i').removeClass('fa-volume-up').addClass('fa-volume-off');
            } else {
                soundBtn.find('i').removeClass('fa-volume-off').addClass('fa-volume-up');
            }
        });
        fullScreenBtn.on('click', function() {
            if (plainVideo.requestFullscreen) {
                plainVideo.requestFullscreen();
            } else if (plainVideo.webkitRequestFullscreen) {
                plainVideo.webkitRequestFullscreen();
            } else if (plainVideo.mozRequestFullscreen) {
                plainVideo.mozRequestFullscreen();
            } else if (plainVideo.webkitEnterFullscreen) {
                plainVideo.webkitEnterFullscreen();
            }
        });
        const config = {
            root: document.body,
            threshold: 0.5,
        };
        if ($(window).width() > 992) {
            const observer = new window.IntersectionObserver(
                ([entry]) => {
                    if (entry.isIntersecting) {
                        if (plainVideo.paused) {
                            plainVideo.muted = true;
                            plainVideo.play();
                            playBtn.fadeOut();
                        }
                    } else {
                        plainVideo.pause();
                    }
                }, config);
            observer.observe(plainVideo);
        }
    });
};

$(window).on('load', function () {
    productVideoInit();
});

module.exports = {
    productVideoInit,
};